import { ContentLayout, Header, SpaceBetween } from '@cloudscape-design/components';
import { CampaignTable, useCampaigns } from '@features/campaigns';

/**
 * Campaigns list page. Lists every campaign configuration in the portal.
 * Each row opens the individual campaign page, which hosts the CSV upload.
 */
export function CampaignListPage() {
  const { campaigns, isLoading, error, refetch } = useCampaigns();

  return (
    <ContentLayout
      header={
        <Header
          variant="h1"
          counter={isLoading ? undefined : `(${campaigns.length})`}
          description="Contact centre campaigns available in the portal."
        >
          Campaigns
        </Header>
      }
    >
      <SpaceBetween size="m">
        <CampaignTable
          items={campaigns}
          isLoading={isLoading}
          error={error}
          onRetry={refetch}
        />
      </SpaceBetween>
    </ContentLayout>
  );
}
